import React, { useState, useRef, useEffect } from 'react'
import swal from 'sweetalert';
import axios from "axios";
import { getApiHeader } from 'utlis/commonfunctions'
import done from '../../../../assets/images/done.png';
import DropIn from 'braintree-web-drop-in-react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { Button } from '@mui/material';
import { ThreeDots } from 'react-loader-spinner'




const SERVER_URL = process.env.REACT_APP_API_URL;
function Payment({paymentToken,setShowPayment,getSummarydata,setShowSummary,retailerWalletBalance, grandTotal,walletUsedAmount, subtotal,discount}) {

  console.log('grandTotal',grandTotal);
  console.log('subtotal',subtotal);

  const [loading, setLoading] = useState(false);
  const instanceRef = useRef(null);
  const [clientToken, setClientToken] = useState("")
  const [defaultCard, setdefaultCard] = useState("")
  const [existingCard, setExistingCard] = useState(0)
  const [disabled, setDisabled] = useState(false)
  const [checkBox, setCheckBox] = useState(false)
  const [checkBoxError, setCheckBoxError] = useState(false)
  const [paymentGateway, setPaymentGateWay] = useState(null)


  const styles = {
    wrapper: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backdropFilter: "blur(1px)",
      zIndex: 9999,
    },
  };






  useEffect(() => {
    fetchDefaultCard()
  }, [])






  const fetchDefaultCard = async () => {
    try {
      const headers = await getApiHeader();
      setLoading(true)
      const response = await axios.get(`${SERVER_URL}retailer-default-card`,
        {
          headers: headers,
        }
      );
      if (response?.status === 200) {
        const paymentMethods = response?.data?.data?.payment_methods;
        console.log("payment Methods", paymentMethods)
        if (typeof paymentMethods === "object" && !Array.isArray(paymentMethods) && paymentMethods !== null) {
          setdefaultCard(paymentMethods);
          setExistingCard(1);
          setLoading(false);
        } else {
          fetchToken();
        }
      } else {
        fetchToken();
      }

    } catch (error) {
      console.log("entry into catch  case")
      fetchToken();

    }
  };



  const fetchToken = async () => {
    try {
      setLoading(true);
      const headers = await getApiHeader();
  
      
      const response = await axios.get(
        `${SERVER_URL}purchase-physical-recharge-vouchers/client-token`,
        { headers } 
      );
  
      if (response.status === 200) {
        const token = response.data?.data?.clientToken; 
        if (token) {
          setClientToken(token);
          setPaymentGateWay(true);
         setTimeout(()=>{
          setLoading(false)
         },5000)


        } else {
          console.warn("Client token is empty.");
        }
      }
    } catch (error) {
      console.error("Error fetching client token:", error.message);
    } finally {
      // setLoading(false);
    }
  };
  



  const handleCheckBox = () => {
    setCheckBox((prevCheckBox) => {
      const newCheckBoxState = !prevCheckBox;

      if (newCheckBoxState) {
        // If checked, clear error and enable button
        setCheckBoxError(false);
        setDisabled(false);
      } else {
        // If unchecked, set error and disable button
        setCheckBoxError(true);
        setDisabled(true);
      }

      return newCheckBoxState;
    });
  }

  
  const walletPaymentSubmit = async (event) => {
    try {
      event.preventDefault()

      setLoading(true)
      setDisabled(true)
      let nonce = null;

      // if (existingCard === 0) {
      //   const paymentMethod = await instanceRef.current.requestPaymentMethod();
      //   nonce = paymentMethod.nonce;
      // }
      const headers = await getApiHeader();
      const payload = {
        payment_system_token:paymentToken,
        payment_method_nonce:nonce,
        sub_total:subtotal,
      };

      const response = await axios.post(
        `${SERVER_URL}purchase-physical-recharge-vouchers/payment`,
        payload,
        { headers }
      );

      if (response.status === 200) {
         console.log("summary daataw",response.data.data)
        //  console.log("response",response.data.data.message)
        getSummarydata(response.data.data)
        // swal({
        //   title: "Success",
        //   text: response?.data?.message,
        //   icon: "success",
        //   button: "Close",
        // }).then(() => {
        //   setShowPayment(false);
        //   setShowSummary(true);
        // });
        setShowPayment(false);
        setShowSummary(true);
        setLoading(false)
      } else { }
    } catch (error) {
      if (error.name === "DropinError") {
        setDisabled(false)
      //  swal("Error in Payment", error.message, "warning");
      }else if(error?.response?.data?.message){
        swal({
          title: "error",
          text: error?.response?.data?.message,
          icon: "error",
          button: "Close"
        })
      }

      setLoading(false)
      // const message = error?.response?.data?.message
      
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentSubmit = async (event) => {
    try {
      event.preventDefault()
      if (!checkBox) {
        setCheckBoxError(true);
        setDisabled(true);
        return;
      }

      setLoading(true)
      setDisabled(true)
      let nonce = null;

      if (existingCard === 0) {
        const paymentMethod = await instanceRef.current.requestPaymentMethod();
        nonce = paymentMethod.nonce;
      }

      const headers = await getApiHeader();
      const payload = {
        payment_system_token:paymentToken,
        payment_method_nonce:nonce,
        sub_total: subtotal,
      };

      const response = await axios.post(
        `${SERVER_URL}purchase-physical-recharge-vouchers/payment`,
        payload,
        { headers }
      );

      if (response.status === 200) {
         console.log("summary daataw",response.data.data)
        //  console.log("response",response.data.data.message)
        getSummarydata(response.data.data)
        // swal({
        //   title: "Success",
        //   text: response?.data?.message,
        //   icon: "success",
        //   button: "Close",
        // }).then(() => {
        //   setShowPayment(false);
        //   setShowSummary(true);
        // });
        setShowPayment(false);
        setShowSummary(true);
        setLoading(false)
      } else { }
    } catch (error) {
      if (error.name === "DropinError") {
        setDisabled(false)
      //  swal("Error in Payment", error.message, "warning");
      }else if(error?.response?.data?.message){
        swal({
          title: "error",
          text: error?.response?.data?.message,
          icon: "error",
          button: "Close"
        })
      }

      setLoading(false)
      // const message = error?.response?.data?.message
      
    } finally {
      setLoading(false);
    }
  };





  


  return (
    <div>

<>
      {loading && (
        <div style={styles.wrapper}>
          <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#e20e75"
            radius="9"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}

      {/* <div className="formbold-main-wrapper">
        <div className="col-lg-4 payment-wrapper">

            <div className="payment-gateway-wrapper">  
          {defaultCard && existingCard === 1 ? (
            <div className="recharge-defaultCard col-lg-12">
              <div className="recharge-defaultCardBox">
                <p>Paying With Card</p>
                <ul className="recharge-defaultCardDetails">
                  <li>
                    <img src={defaultCard.imageUrl} alt="Card Image" />
                  </li>
                  <li>
                    <span>Ending In {defaultCard.last4}</span>
                    <span>{defaultCard.cardType}</span>
                  </li>
                  <li>
                    <img src={done} alt="Done Icon" />
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            paymentGateway && (
              <div >
                <DropIn
                  options={{
                    authorization: clientToken,
                  }}
                  onInstance={(instance) => (instanceRef.current = instance)}
                />
              </div>
            )
          )}

          <label className="check-box add-mb-accept-pay">
            <input
              type="checkbox"
              required=""
              id="agreeTerms"
              title="Please check and agree to the terms and conditions"
              onChange={handleCheckBox}
            />
            I have read and accept the{' '}
            <a
              target="_blank"
              href="https://www.telsim.com.au/website-terms-conditions/"
              rel="noopener noreferrer"
            >
              Terms & Conditions
            </a>
            , the Acceptable Use Policy, and the{' '}
            <a
              target="_blank"
              href="https://www.telsim.com.au/website-privacy-policy/"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>{' '}
            for my Telsim service.
            <span className="tick"></span>
          </label>

          {checkBoxError && !checkBox && (
            <p className="error-label">
              Please check and agree to the terms and conditions
            </p>
          )}

          <div textAlign="center" mt={4}>
            <Button
              variant="outlined"
              disabled={disabled}
              sx={{
                backgroundColor: '#C11D6C',
                color: '#fff',
                // width: { xs: '100%', sm: '440px' },
                width:'100%',
                '&:hover': {
                  backgroundColor: '#9C1554',
                },
              }}
              onClick={handlePaymentSubmit}
            >
              Submit
            </Button>
          </div>
        </div>


        </div>
      </div> */}

      <div className="formbold-main-wrapper">
        <div className="col-lg-4 payment-wrapper">

          <div className="payment-gateway-wrapper">

            {/* Conditional rendering based on retailerWalletBalance vs grandTotal */}
            {grandTotal > 0 ? (
              // Render Card Payment if wallet balance is not enough
              <>
                {defaultCard && existingCard === 1 ? (
                  <div className="recharge-defaultCard col-lg-12">
                    <div className="recharge-defaultCardBox">
                      <p>Paying With Card</p>
                      <ul className="recharge-defaultCardDetails">
                        <li>
                          <img src={defaultCard.imageUrl} alt="Card Image" />
                        </li>
                        <li>
                          <span>Ending In {defaultCard.last4}</span>
                          <span>{defaultCard.cardType}</span>
                        </li>
                        <li>
                          <img src={done} alt="Done Icon" />
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  paymentGateway && (
                    <div>
                      <DropIn
                        options={{
                          authorization: clientToken,
                        }}
                        onInstance={(instance) => (instanceRef.current = instance)}
                      />
                    </div>
                  )

                  
                )}

<label className="check-box add-mb-accept-pay">
              <input
                type="checkbox"
                required=""
                id="agreeTerms"
                title="Please check and agree to the terms and conditions"
                onChange={handleCheckBox}
              />
              I have read and accept the{' '}
              <a
                target="_blank"
                href="https://www.telsim.com.au/website-terms-conditions/"
                rel="noopener noreferrer"
              >
                Terms & Conditions
              </a>
              , the Acceptable Use Policy, and the{' '}
              <a
                target="_blank"
                href="https://www.telsim.com.au/website-privacy-policy/"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>{' '}
              for my Telsim service.
              <span className="tick"></span>
            </label>

            {checkBoxError && !checkBox && (
              <p className="error-label">
                Please check and agree to the terms and conditions
              </p>
            )}

            <div textAlign="center" mt={4}>
              <Button
                variant="outlined"
                disabled={disabled}
                sx={{
                  backgroundColor: '#C11D6C',
                  color: '#fff',
                  width: '100%',
                  '&:hover': {
                    backgroundColor: '#9C1554',
                  },
                }}
                onClick={handlePaymentSubmit}
              >
                Submit
              </Button>
            </div>
              </>
            ): (
              // Render Wallet Payment if balance is enough
              <div className="recharge-wallet-payment">
                    <p style={{color:'#344567'}} className="mb-2">
                  <strong>Subtotal:</strong>{" "}
                  <span className="text-muted">
                    ${subtotal}
                  </span>
                </p>
                 <p style={{color:'#344567'}} className="mb-2">
                  <strong>Discount Applied:</strong>{" "}
                  <span className="text-muted">
                   - ${discount}
                  </span>
                </p>
                <p style={{color:'#344567'}} className="mb-2">
                  <strong>Wallet Credit Used:</strong>{" "}
                  <span className="text-muted">
                  -  ${walletUsedAmount}
                  </span>
                </p>
                <p style={{color:'#344567'}} className="mb-3">
                  <strong>Grand Total:</strong>{" "}
                  <span className="text-muted">
                    ${grandTotal}
                  </span>
                </p>
                {/* <button onClick={handlePaymentSubmit}></button> */}
                
                <div textAlign="center" mt={4}>
                    <Button
                      variant="outlined"
                      disabled={disabled}
                      sx={{
                        backgroundColor: '#C11D6C',
                        color: '#fff',
                        width: '100%',
                        '&:hover': {
                          backgroundColor: '#9C1554',
                        },
                      }}
                      onClick={walletPaymentSubmit}
                    >
                      Pay with Wallet
                    </Button>
                  </div>

              </div>
            )}

            {/* Checkbox for terms and conditions */}
          
          </div>

        </div>
      </div>


    </>

    </div >

  )
}

export default Payment